import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CellCoordinates } from '../../types/Spreadsheet';
import { RootState } from '../store';

interface FocusState {
  focusedCell: CellCoordinates | null;
}

const initialState: FocusState = {
  focusedCell: null
};

const focusSlice = createSlice({
  name: 'focus',
  initialState,
  reducers: {
    setFocusedCell( state, action: PayloadAction<CellCoordinates | null> ) {
      state.focusedCell = action.payload;
    }
  }
});

export const { setFocusedCell } = focusSlice.actions;
export default focusSlice.reducer;

// Selector
export const selectFocusedCell = ( state: RootState ) => state.spreadsheet.focus.focusedCell;